import { ReactNode } from 'react';
import { Link } from 'react-router';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import { TextV2 } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

type DashboardCardProps = {
  disabled?: boolean;
  href: string;
  Icon: React.ReactElement;
  textPrimary: string;
  textSecondary?: string;
  children?: ReactNode;
};

const DashboardCard = ({
  disabled = false,
  href,
  Icon,
  textPrimary,
  textSecondary,
  children,
}: DashboardCardProps) => {
  return (
    <Card
      variant="outlined"
      sx={(theme) => ({
        height: '100%',
        border: `1px solid ${theme.palette.grey[500]}`,
        borderBottom: `0.2em solid ${theme.palette.primary.main}`,
        opacity: disabled ? '0.5' : 'undefined',
        pointerEvents: disabled ? 'none' : 'undefined',
      })}
    >
      <CardActionArea
        sx={(theme) => ({
          width: '100%',
          height: '100%',
          padding: `${theme.spacing(spacingSizeMap.XS)} ${theme.spacing(
            spacingSizeMap.L,
          )} ${theme.spacing(spacingSizeMap.L)} ${theme.spacing(
            spacingSizeMap.XS,
          )}`,
        })}
        component={Link}
        to={href}
      >
        <CardContent>
          {Icon}
          <Box
            sx={{
              mb: (theme) => theme.spacing(spacingSizeMap.S),
              mt: (theme) => theme.spacing(spacingSizeMap.S),
            }}
          >
            <TextV2 variant="h3" color="primary">
              {textPrimary}
            </TextV2>
          </Box>
          {textSecondary && (
            <TextV2 variant="bodyBold" color="textSecondary">
              {textSecondary}
            </TextV2>
          )}
          {children}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default DashboardCard;
